var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-tip"},[_c('img',{staticClass:"image",attrs:{"src":require('@/assets/image/no_data.png')}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.displayTip))])])
}
var staticRenderFns = []

export { render, staticRenderFns }